// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM6.99805 11.998H9.00195V14.002H6.99805V11.998ZM10.998 11.998H13.002V14.002H10.998V11.998ZM17.002 11.998V14.002H14.998V11.998H17.002Z"}}]};

const FolderDetailsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-details-filled',
    ref,
    icon: element,
  },
));

FolderDetailsFilledIcon.displayName = 'FolderDetailsFilledIcon';

export default FolderDetailsFilledIcon;
